import { ValidationError } from '@angular/forms/signals';

export type SignalFormErrorMessages = Record<string, string>;

const DEFAULT_ERROR_MESSAGES: Record<
  string,
  (error: ValidationError) => string
> = {
  required: () => 'This field is required',
  email: () => 'Enter a valid email address',
  pattern: () => 'Enter a valid value',
  minLength: (error) =>
    `Must be at least ${readErrorParam(error, 'minLength')} characters`,
  maxLength: (error) =>
    `Must be ${readErrorParam(error, 'maxLength')} characters or less`,
  min: (error) => `Must be at least ${readErrorParam(error, 'min')}`,
  max: (error) => `Must be ${readErrorParam(error, 'max')} or less`,
  minDate: () => 'Date is too early',
  maxDate: () => 'Date is too late',
};

const FALLBACK_ERROR_MESSAGE = 'Invalid value';

function readErrorParam(error: ValidationError, key: string): unknown {
  return (error as unknown as Record<string, unknown>)[key];
}

export function resolveErrorMessage(
  error: ValidationError | undefined,
  overrides: SignalFormErrorMessages = {},
): string {
  if (!error) return '';
  const override = overrides[error.kind];
  if (override) return override;
  if (error.message) return error.message;
  return DEFAULT_ERROR_MESSAGES[error.kind]?.(error) ?? FALLBACK_ERROR_MESSAGE;
}
